// @ts-nocheck
import {
  FETCH_SUBMITTED_QUOTES_FAILURE,
  FETCH_SUBMITTED_QUOTES_REQUEST,
  FETCH_SUBMITTED_QUOTES_SUCCESS,
  SEND_MESSAGE_FAILURE,
  SEND_MESSAGE_REQUEST,
  SEND_MESSAGE_SUCCESS,
} from "../../constants/config/requestedQuote";

const initialState = {
  quotes: [],
  isLoading: false,
  sLoading: false,
  searchString: "",
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
  addLoading: false,
};

const requestedQuoteReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_SUBMITTED_QUOTES_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload,
      };
    case FETCH_SUBMITTED_QUOTES_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_SUBMITTED_QUOTES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        quotes: action?.payload?.data,
        totalPages: action?.payload?.totalPages,
        currentPage: action?.payload?.currentPage,
      };

    // send message
    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sLoading: true,
      };

    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        sLoading: false,
      };

    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        sLoading: false,
      };

    default:
      return state;
  }
};

export default requestedQuoteReducer;